import {
  StyleSheet,
  Text,
  View,
  ScrollView,
  FlatList,
  Image,
  TextInput,
  Pressable,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { format } from "date-fns";
import { CommonButton } from "../../../common/CommonButton";
import { TouchableOpacity } from "react-native-gesture-handler";
import { toast } from "react-toastify";
import EventChatBottomSheet from "./Common/EventChatBottomSheet";
import SignUpModal from "./Modals/SignUpModal";
import BuyBeltaModal from "./BeltScreens/BuyBeltaModal";
import BuyTicketModal from "./Modals/BuyTicketModal";
import WinnerModal from "./Modals/WinnerModal";
import DisputeAlertModal from "./Modals/DisputeAlertModal";
import PurchaseSuccessModal from "./Modals/PurchaseSuccessModal";
import SuccessFullSignUpModal from "./Modals/SuccessFullSignUpModal";
import GetReadyModal from "./Modals/GetReadyModal";
import InviteSocialMediaModal from "../Event/InviteSocialMediaModal";
import { AppScreens } from "../../Utility/AppScreens";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { base_url, endpoints } from "../../../Api/configs";
import { getLoginData } from "../../../utility/AppStoreData";
import { ShowLoader } from "../../../common/ShowLoader";
import { fetchEventDetails } from "../../../services/eventsAPI";
import { checkAndHandleTokenExpiration } from "../../../utility/auth/authTokenHandler";
import { clearAllCaches } from "../../../utility/cacheManager";
import ImageComponent from "../../../Components/ImageComponent";
import NoDataFound from "../../../Components/NoDataFound";
import { getUserProfile } from "../../../services/authAPI";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import HelpChatComponent from "./HelpChatComponent";
import EventChatComponent from "./Common/EventChatComponent";
import GameShowDetailSkeleton from "../../../Components/skeleton-components/GameShowDetailSkeleton";
import GameShowCardSkeleton from "../../../Components/skeleton-components/GameShowCardSkeleton";
import GameShowEventDetailSkeleton from "../../../Components/skeleton-components/GameShowEventDetailSkeleton";
import PlayerViewSkeleton from "../../../Components/skeleton-components/PlayerViewSkeleton";
import Skeletons from "../../../Components/skeleton-components/Skeletons";
import OnGoingEventDetils from "../../../Components/ongoing-common-components/general-components/OnGoingEventDetils";
import CreateEventTooltip from "../../../Components/home-common-components/CreateEventTooltip";
import TimerComponent from "../../../Components/ongoing-common-components/general-components/TimerComponent";
import Header from "./Common/Header";
import EventDetailCard from "./OnGoingEvents/EventDetailCard";
import { EVENT_STATUS } from "../../../utility/LiveStreamSocket/LiveStreamConfig";
import { useNotifications } from "../../../context/NotificationContext";
import EventDetailScreenCard from "./OnGoingEvents/EventDetailScreenCard";
import MobileGameShowCard from "./OnGoingEvents/MobileGameShowCard";
import Avatar from "../../../Components/choose-avatar-components/Avatar";
import { ScreenBGGradientView } from "../../../common/CommonView";
import SponsorSection from "../../../Components/live-streaming-common-components/SponsorSection";
import MobileChatBottomSheet from "../../../Components/live-streaming-common-components/MobileChatBottomSheet";
import { useLiveStream } from "../../../context/LiveStreamContext";
import SvgImage from "../../../Components/choose-avatar-components/SvgImage";

export default function GameShowScreen({ route }) {
  const { eventID } = route.params;
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [openChat, setOpenChat] = useState(false);
  const [openSignUp, setOpenSignUp] = useState(false);
  const [eventChat, setEventChat] = useState(false);
  const [isBuyTicket, setIsBuyTicket] = useState(false);
  const [screenName, setScreenName] = useState("free");
  const [isShare, setIsShare] = useState(false);
  const [details, setDetails] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [accessToken, setAccessToken] = useState("");
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [userProfileData, setUserProfileData] = useState(null);
  const [isMinAttendees, setIsMinAttendees] = useState(false);
  const [isMoreTimeLeft, setIsMoreTimeLeft] = useState(false);
  const [eventTooltipVisible, setEventTooltipVisible] = useState(false);
  const [fetchChatHistoryTrigger, setFetchChatHistoryTrigger] = useState(false);
  const [showGetReadyModal, setShowGetReadyModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Overview");
  const { signUpUser, eventStatus, updateNotification } = useNotifications();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Tab data for mobile navigation
  const tabData = useMemo(
    () => [
      { id: 1, title: "Overview" },
      { id: 2, title: "Players" },
      { id: 3, title: "Viewers" },
    ],
    []
  );

  // LiveStream Context for unified chat
  const {
    connectToEvent,
    disconnectFromEvent,
    audienceData,
    setAudienceData,
    setOrganizerData,
    sendLike,
    alreadyLiked,
    loader: chatLoader,
    setUserData: setContextUserData,
  } = useLiveStream();

  // Chat state
  const [chatConnected, setChatConnected] = useState(false);
  const [inviteSocialMediaModal, setInviteSocialMediaModal] = useState(false);

  // Use ref to track connection state and prevent infinite loop
  const connectionInitialized = useRef(false);

  useEffect(() => {
    checkAndHandleTokenExpiration(navigation);
    getLoginUserData();
    if (eventID) {
      getEventDetails(eventID);
    }
  }, [eventID]);

  useEffect(() => {
    if (refreshAPICall) {
      getEventDetails(eventID);
      setRefreshAPICall(false);
    }
  }, [refreshAPICall, eventID]);

  const userProfileAPI = async (AccessToken?: string) => {
    try {
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200) {
        setUserProfileData(responseBody);
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        await clearAllCaches();
        console.log("Unauthorized access, logging out silently");
        navigation.dispatch(StackActions.replace(AppScreens.LoginWebScreen));
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      console.log("Authorization failed: " + error.message);
      toast.error(error.message);
    }
  };

  const getEventDetails = async (eventID) => {
    setShowLoader(true);
    const userData = await getLoginData();

    try {
      const data = await fetchEventDetails(eventID, userData.AccessToken);
      if (data) {
        setDetails(data);

        const eventStartTime = new Date(data.eventStartTime).getTime();
        const now = Date.now();
        const timeDifference = eventStartTime - now;

        if (timeDifference <= 60 * 60 * 1000 && timeDifference > 10 * 1000) {
          setShowGetReadyModal(true);
          return;
        } else if (timeDifference <= 10 * 1000) {
          navigateToScreen(navigation, AppScreens.LiveStreaming, {
            eventId: data.eventID,
          });
          return;
        }

        const attendeeIDs = data.attendeeIDs || [];
        const newUsersData = attendeeIDs.map(
          (username: String, index: any) => ({
            id: index + 1,
            username: username,
            userImage: AppImages.icApple,
          })
        );

        setUsersData(newUsersData);
      } else {
        handleErrorResponse(data.statusCode, data.body.error);
      }
    } catch (error) {
      console.error("Error fetching event");
      navigateToScreen(navigation, AppScreens.Home);
    } finally {
      setShowLoader(false);
    }
  };

  const signUpNumber = 70;
  const requiredNumber = details?.minimumAttendees
    ? details.minimumAttendees - signUpNumber
    : 0;
  const totalPercentage = details?.minimumAttendees
    ? (signUpNumber * 100) / details.minimumAttendees
    : 0;
  const currentDate = new Date();

  const isUserCheckedIn =
    userData?.username === details?.organiserId
      ? details?.checkInStatus?.organiser
      : details?.checkInStatus?.challenger;

  const handleErrorResponse = (statusCode, errorMessage) => {
    if (statusCode === 400) {
      toast.error("Bad Request");
    } else if (statusCode > 400 && statusCode < 420) {
      toast.error("Unauthorized");
    } else if (statusCode >= 500) {
      toast.error("Internal Server Error");
    } else {
      toast.error(errorMessage);
    }
    navigateToScreen(navigation, AppScreens.Home);
  };

  const getLoginUserData = async () => {
    const data = await getLoginData();
    if (data) {
      setUserData(data);
      userProfileAPI(data.AccessToken);
      setAccessToken(data.AccessToken);
    }
  };

  useEffect(() => {
    let hasNavigated = false;
    const calculateTimeLeft = () => {
      if (details && details.eventStartTime) {
        const eventDate = new Date(details.eventStartTime).getTime();
        const now = Date.now();
        const difference = eventDate - now;
        if (difference > 60 * 60 * 1000) {
          setTimeLeft({
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
          });
        } else if (
          difference <= 60 * 60 * 1000 &&
          difference > 10 * 1000 &&
          !hasNavigated
        ) {
          hasNavigated = true;
          setShowGetReadyModal(true);
        } else if (difference <= 10 * 1000 && difference > 0 && !hasNavigated) {
          hasNavigated = true;
          navigateToScreen(navigation, AppScreens.LiveStreaming, {
            eventId: details.eventID,
          });
        } else {
          setTimeLeft({
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
          });
        }
      }
    };
    const startDate = new Date(details?.eventStartTime);
    const timeDifference = startDate.getTime() - currentDate.getTime();
    const hoursLeft = timeDifference / (1000 * 60 * 60);
    setIsMinAttendees(requiredNumber > signUpNumber ? true : false);
    if (hoursLeft <= 24 && hoursLeft >= 0) {
      setIsMoreTimeLeft(false);
    } else {
      setIsMoreTimeLeft(true);
    }

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, [details]);

  const date = useMemo(
    () => (details ? new Date(details?.eventStartTime) : new Date()),
    [details]
  );
  const formattedDate = details
    ? format(date, "EEEE, MMMM d, yyyy, 'at' h:mm")
    : "";

  const isUserAttendee = useMemo(() => {
    if (details && userData?.username) {
      const isInAttendees =
        details.attendeeIDs?.includes(userData.username) || false;
      const isInParticipants =
        details.participantIDs?.includes(userData.username) || false;
      return isInAttendees || isInParticipants;
    }
    return false;
  }, [details, userData]);
  const isPlayer = useMemo(() => {
    if (details?.participantIDs && userData?.username) {
      return details.participantIDs.includes(userData.username);
    }
    return false;
  }, [details, userData]);

  // Connect to LiveStream WebSocket for unified chat
  useEffect(() => {
    if (!userData || !eventID || !isUserAttendee) {
      if (connectionInitialized.current) {
        console.log("User is not attendee or data missing, disconnecting...");
        disconnectFromEvent();
        connectionInitialized.current = false;
      }
      setChatConnected(false);
      return;
    }

    if (connectionInitialized.current) {
      return;
    }

    const initChatConnection = async () => {
      try {
        console.log("=== GameShowScreen: Connecting to LiveStream chat ===", {
          username: userData.username,
          eventID,
          isUserAttendee,
        });

        setContextUserData(userData);
        connectToEvent(
          userData.username,
          eventID,
          userData.AccessToken,
          "audience"
        );
        connectionInitialized.current = true;

        setTimeout(() => {
          console.log("=== GameShowScreen: Chat connection ready ===");
          setChatConnected(true);
        }, 1500);
      } catch (error) {
        console.error("Error connecting to LiveStream chat:", error);
        setChatConnected(false);
        connectionInitialized.current = false;
      }
    };

    initChatConnection();

    return () => {
      if (connectionInitialized.current) {
        console.log("Component unmounting, disconnecting from LiveStream chat");
        disconnectFromEvent();
        connectionInitialized.current = false;
        setChatConnected(false);
      }
    };
  }, [userData, eventID, isUserAttendee]);

  // Reconnect to chat when chat tab is opened (in case socket was disconnected)
  useEffect(() => {
    if (eventChat && isUserAttendee && userData && eventID) {
      // If chat is opened but not connected, try to reconnect
      if (!chatConnected) {
        console.log(
          "=== GameShowScreen: Chat opened but not connected, attempting reconnection ==="
        );

        const reconnectChat = async () => {
          try {
            // Reset connection state
            if (connectionInitialized.current) {
              console.log(
                "Disconnecting previous connection before reconnecting..."
              );
              disconnectFromEvent();
              connectionInitialized.current = false;
            }

            // Wait a bit before reconnecting
            await new Promise((resolve) => setTimeout(resolve, 500));

            console.log("Reconnecting to chat...", {
              username: userData.username,
              eventID,
            });

            setContextUserData(userData);
            connectToEvent(
              userData.username,
              eventID,
              userData.AccessToken,
              "audience"
            );
            connectionInitialized.current = true;

            setTimeout(() => {
              console.log(
                "=== GameShowScreen: Chat reconnected successfully ==="
              );
              setChatConnected(true);
            }, 1500);
          } catch (error) {
            console.error("Error reconnecting to chat:", error);
            setChatConnected(false);
            connectionInitialized.current = false;
          }
        };

        reconnectChat();
      }
    }
  }, [eventChat, isUserAttendee, chatConnected, userData, eventID]);

  // Listen for challenge status updates and refresh event details
  useEffect(() => {
    if (eventStatus && eventStatus.eventId === eventID) {
      console.log("=== GameShowScreen: Challenge status update received ===", {
        eventId: eventStatus.eventId,
        status: eventStatus.status,
        challengeDetails: eventStatus.challengeDetails,
      });

      // Refresh event details to get updated participant information
      console.log("Refreshing event details due to challenge status update...");
      getEventDetails(eventID);

      // If chat is not connected but user is attendee, try to connect
      if (isUserAttendee && !chatConnected && userData) {
        console.log("Challenge accepted - connecting to chat...");
        setTimeout(() => {
          setContextUserData(userData);
          connectToEvent(
            userData.username,
            eventID,
            userData.AccessToken,
            "audience"
          );
          connectionInitialized.current = true;
          setTimeout(() => {
            setChatConnected(true);
          }, 1500);
        }, 500);
      }
    }
  }, [eventStatus]);

  // Listen for challenge response notifications (for organizer)
  useEffect(() => {
    if (
      updateNotification &&
      typeof updateNotification === "object" &&
      "challengeId" in updateNotification &&
      updateNotification.challengeId === eventID
    ) {
      console.log(
        "=== GameShowScreen: Challenge response notification received ===",
        {
          challengeId: updateNotification.challengeId,
          response: updateNotification.response,
        }
      );

      // Refresh event details to get updated participant information
      console.log("Refreshing event details due to challenge response...");
      getEventDetails(eventID);
    }
  }, [updateNotification]);

  const signUpUserDetails = (signUpUser || [])
    .filter(
      (notif) =>
        notif.type === "user-registered" &&
        notif.eventID === details?.eventID &&
        notif.data?.userID
    )
    .map((notif) => notif.data);

  const participantIDs = details?.participantIDs || [];
  const mergedDetails = [
    ...(details?.attendeeDetails || []),
    ...(signUpUserDetails || []),
  ]
    .filter((item) => !participantIDs.includes(item.userID))
    .reduce((unique, item) => {
      if (!unique.some((user) => user.userID === item.userID)) {
        unique.push(item);
      }
      return unique;
    }, []);
  const isStreamConnected = "true";
  const IsEventCanceled = details?.status === EVENT_STATUS.CANCEL;

  return (
    <>
      <View style={{ flex: 1 }}>
        <ScreenBGGradientView />
        <Header
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
          btnWalletTapped={() => {}}
          btnStartTutorialTapped={() => {}}
          btnMessageTapped={() => {}}
          btnNotificationTapped={() => {}}
          btnProfileTapped={() => {}}
        />

        {/* Fixed Header Section - Not scrollable */}
        <View style={{ paddingHorizontal: "2.5%", paddingTop: 0 }}>
          {/* Header section for both mobile and desktop */}
          {deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG ? (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 0,
              }}
            >
              {/* Left section: Back arrow + Event text */}
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
              >
                <TouchableOpacity
                  onPress={() => {
                    navigation.dispatch(StackActions.pop());
                  }}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: "#374151",
                    backgroundColor: "rgba(31, 41, 55, 0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={AppImages.icArrowLeft}
                    style={{ width: 20, height: 20, tintColor: "#FFFFFF" }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
                <Text
                  style={{
                    fontSize: 24,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    height: 40,
                    lineHeight: 40,
                  }}
                >
                  Event
                </Text>
              </View>

              {/* Right section: Free event badge + Share button + Sign up button */}
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
              >
                {details?.eventType === "Public" &&
                  deviceSize !== DEVICE_SIZES.XS &&
                  deviceSize !== DEVICE_SIZES.SM &&
                  deviceSize !== DEVICE_SIZES.MD &&
                  deviceSize !== DEVICE_SIZES.LG && (
                    <View
                      style={{
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        borderRadius: 8,
                        backgroundColor: "rgba(31, 41, 55, 0.8)",
                        borderWidth: 1,
                        borderColor: "#374151",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 14,
                          fontWeight: "600",
                          color: "#FFFFFF",
                        }}
                      >
                        Free event
                      </Text>
                    </View>
                  )}
                <TouchableOpacity
                  onPress={() => setIsShare(true)}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: "#374151",
                    backgroundColor: "rgba(31, 41, 55, 0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={AppImages.Ko_Share}
                    style={{ width: 20, height: 20 }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
                {!isUserAttendee && (
                  <Pressable
                    onPress={() => {
                      if (details?.eventType === "Public") {
                        setOpenSignUp(true);
                      } else {
                        setIsBuyTicket(true);
                      }
                    }}
                    style={{
                      paddingHorizontal: 16,
                      borderRadius: 8,
                      backgroundColor: "#DC2626",
                      height: 40,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Sign up
                    </Text>
                  </Pressable>
                )}
              </View>
            </View>
          ) : (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* Left section: Back arrow + Event text */}
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
              >
                <TouchableOpacity
                  onPress={() => {
                    navigation.dispatch(StackActions.pop());
                  }}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: "#374151",
                    backgroundColor: "rgba(31, 41, 55, 0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={AppImages.icArrowLeft}
                    style={{ width: 20, height: 20, tintColor: "#FFFFFF" }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
                <Text
                  style={{
                    fontSize: 24,
                    fontWeight: "700",
                    color: "#FFFFFF",
                    height: 40,
                    lineHeight: 40,
                  }}
                >
                  Event
                </Text>
              </View>

              {/* Right section: Free event badge + Share button + Sign up button */}
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
              >
                {details?.eventType === "Public" && (
                  <View
                    style={{
                      paddingHorizontal: 16,
                      borderRadius: 8,
                      backgroundColor: "rgba(31, 41, 55, 0.8)",
                      borderWidth: 1,
                      borderColor: "#374151",
                      height: 40,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                        color: "#FFFFFF",
                      }}
                    >
                      Free event
                    </Text>
                  </View>
                )}
                <TouchableOpacity
                  onPress={() => setIsShare(true)}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: "#374151",
                    backgroundColor: "rgba(31, 41, 55, 0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={AppImages.Ko_Share}
                    style={{ width: 20, height: 20 }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
                {!isUserAttendee && (
                  <TouchableOpacity
                    onPress={() => {
                      if (details?.eventType === "Public") {
                        setOpenSignUp(true);
                      } else {
                        setIsBuyTicket(true);
                      }
                    }}
                    style={{
                      paddingHorizontal: 16,
                      borderRadius: 8,
                      backgroundColor: "#DC2626",
                      height: 40,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Sign up
                    </Text>
                  </TouchableOpacity>
                )}
              </View>
            </View>
          )}

          {/* Sponsor Section - Fixed, not scrollable */}
          <View style={{ marginVertical: 5 }}>
            <SponsorSection />
          </View>
        </View>
        <View
          style={[
            styles.freeEventView,
            {
              marginHorizontal: 10,
              marginVertical: 5,
              justifyContent: "space-between",
            },
          ]}
        >
          {/* Tab Navigation for Mobile */}
          {deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG ? (
            <View
              style={{
                backgroundColor: AppColors.gray_1B1B1B,
                borderRadius: 12,
                paddingHorizontal: 10,
                marginBottom: 0,
              }}
            >
              <FlatList
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                data={tabData}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    style={{
                      paddingVertical: 12,
                      paddingHorizontal: 20,
                      backgroundColor:
                        selectedTab === item.title
                          ? AppColors.appViolentColor_6D08C3
                          : "transparent",
                      borderRadius: 10,
                      margin: 8,
                      minWidth: 90,
                      alignItems: "center",
                    }}
                    onPress={() => {
                      setSelectedTab(item.title);
                      if (item.title === "Chat") {
                        if (isUserAttendee) {
                          setEventChat(true);
                        } else {
                          toast.error(
                            "Purchase a ticket or sign up for this event to participate in the live chat"
                          );
                        }
                      }
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_12,
                        { color: AppColors.white },
                      ]}
                    >
                      {item.title}
                    </Text>
                  </TouchableOpacity>
                )}
                keyExtractor={(item) => item.id.toString()}
              />
            </View>
          ) : null}
        </View>

        {/* Scrollable Content */}
        <ScrollView
          style={styles.container}
          showsHorizontalScrollIndicator={false}
        >
          {/* Hide this overview section on mobile devices - show only in tab */}
          {deviceSize !== DEVICE_SIZES.XS &&
            deviceSize !== DEVICE_SIZES.SM &&
            deviceSize !== DEVICE_SIZES.MD &&
            deviceSize !== DEVICE_SIZES.LG && (
              <EventDetailScreenCard
                setIsMinAttendees={setIsMinAttendees}
                isMinAttendees={isMinAttendees}
                details={details}
                userData={userData}
                timeLeft={timeLeft}
                hasCheckedIn={isUserCheckedIn}
                setTimeLeft={setTimeLeft}
                isStreamConnected={isStreamConnected}
                isMoreTimeLeft={isMoreTimeLeft}
                setIsMoreTimeLeft={setIsMoreTimeLeft}
                screenName="GameShowScreen"
                IsEventCanceled={IsEventCanceled}
                isLoading={showLoader}
                paddingOnTop={false}
              />
            )}
          {/* Removed Free Event section - now in header */}
          {showLoader ? (
            <GameShowEventDetailSkeleton />
          ) : IsEventCanceled ? (
            <View
              style={[
                styles.freeEventView,
                {
                  marginTop: 15,
                  justifyContent: "space-between",
                  alignItems: "center",
                  ...(deviceSize === DEVICE_SIZES.XS ? { gap: 10 } : {}),
                },
              ]}
            >
              <View
                style={{
                  gap: 10,
                  width: deviceSize === DEVICE_SIZES.XS ? "100%" : 478,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: AppColors.purple_C68DF6, textAlign: "center" },
                  ]}
                >
                  We apologise for the inconvenience and thank you for your
                  understanding. We hope to see you at future events.
                </Text>
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: AppColors.purple_C68DF6, textAlign: "center" },
                  ]}
                >
                  The Esquadifi Team
                </Text>
              </View>
              <CommonButton
                title="Event Canceled"
                onTap={() => {
                  setOpenSignUp(true);
                }}
                buttonStyle={{
                  paddingVertical: 12,
                  paddingHorizontal: 24,
                  backgroundColor: AppColors.red_912121,
                  shadowOpacity: 0,
                  width: 212,
                  borderRadius: 10,
                }}
                textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
              />
            </View>
          ) : false ? (
            <View
              style={[
                styles.freeEventView,
                { marginTop: 15, justifyContent: "space-between" },
              ]}
            >
              {deviceSize === DEVICE_SIZES.XS ? (
                <LinearGradient
                  colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 1 }}
                  style={[
                    styles.deviceflexDirection,
                    {
                      height: "100%",
                      gap: 10,
                      borderRadius: 8,
                      borderWidth: 0.8,
                      borderColor: "#374151",
                      padding: 8,
                    },
                  ]}
                >
                  <View
                    style={{
                      borderRadius: 5,
                      alignSelf: "center",
                      paddingVertical: 5,
                    }}
                  >
                    <View style={{ flexDirection: "row", columnGap: 10 }}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_20,
                          { color: AppColors.white, flex: 1 },
                        ]}
                      >
                        {details?.eventType === "Public"
                          ? "FREE EVENT"
                          : `Available tickets ${
                              details?.ticketPrice ? details?.ticketPrice : 0
                            } `}
                      </Text>
                    </View>
                  </View>

                  <View
                    style={{
                      borderRadius: 5,
                      paddingHorizontal: 5,
                      width: "100%",
                    }}
                  >
                    <View style={{ flexDirection: "row", columnGap: 10 }}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_18,
                          { color: AppColors.white, flex: 1 },
                        ]}
                      >
                        {details?.eventType === "Public"
                          ? "Required Attendees"
                          : "Tickets sold"}
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_24,
                          { color: AppColors.white },
                        ]}
                      >
                        {details ? details.minimumAttendees : ""}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      borderRadius: 5,
                      paddingVertical: 5,
                      paddingHorizontal: 5,
                    }}
                  >
                    <View style={{ flexDirection: "row", columnGap: 10 }}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_18,
                          { color: AppColors.white, flex: 1 },
                        ]}
                      >
                        {details?.eventType === "Public"
                          ? "Signed-Up"
                          : "Tickets Price"}
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_24,
                          { color: AppColors.white },
                        ]}
                      >
                        {details?.eventType === "Public"
                          ? details.attendeeIDs.length
                          : details?.ticketPrice}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      columnGap: 10,
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        setIsShare(true);
                      }}
                      style={{}}
                    >
                      <Image
                        source={AppImages.Ko_ongoing_share}
                        style={{ height: 50, width: 50, cursor: "pointer" }}
                      />
                    </TouchableOpacity>
                    {timeLeft.days === 0 &&
                    timeLeft.hours === 0 &&
                    timeLeft.minutes === 0 &&
                    timeLeft.seconds === 0 ? (
                      <CommonButton
                        title="Go to live event page"
                        onTap={() => {
                          navigateToScreen(
                            navigation,
                            AppScreens.LiveStreaming,
                            {
                              eventId: eventID,
                            }
                          );
                        }}
                        buttonStyle={styles.btnButTicket}
                        textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                      />
                    ) : !isPlayer ? (
                      !isUserAttendee ? (
                        details?.eventType === "Public" ? (
                          <CommonButton
                            title="Sign-Up"
                            onTap={() => {
                              setOpenSignUp(true);
                            }}
                            buttonStyle={styles.btnSignUpStyle}
                            textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                          />
                        ) : (
                          <>
                            <CommonButton
                              title="Buy Ticket now"
                              onTap={() => {
                                setIsBuyTicket(true);
                              }}
                              buttonStyle={styles.btnButTicket}
                              textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                            />
                          </>
                        )
                      ) : details?.eventType === "Public" ? (
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            {
                              color: AppColors.white,
                              width: 170,
                              textAlign: "right",
                              fontSize: 18,
                            },
                          ]}
                          numberOfLines={1}
                          ellipsizeMode="tail"
                        >
                          Already sign-up
                        </Text>
                      ) : (
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            {
                              color: AppColors.white,
                              width: 170,
                              textAlign: "right",
                              fontSize: 18,
                            },
                          ]}
                          numberOfLines={1}
                          ellipsizeMode="tail"
                        >
                          Already Purchased
                        </Text>
                      )
                    ) : null}
                    <CommonButton
                      title="Event Chatcc"
                      onTap={() => {
                        if (isUserAttendee) {
                          setEventChat(true);
                        } else {
                          toast.error(
                            "Purchase a ticket or sign up for this event to participate in the live chat"
                          );
                        }
                      }}
                      buttonStyle={styles.btnEventChatStyle}
                      textStyle={styles.btnEventChatText}
                      image={true}
                      imageUrl={AppImages.KO_GAMESCREEN_CHAT_Icon}
                      imagePosition="pre"
                      imageStyle={{ width: 20, height: 20 }}
                    />
                  </View>
                </LinearGradient>
              ) : (
                <>
                  <View
                    style={{
                      gap: 10,
                      flexDirection: "row",
                      borderRadius: 12,
                    }}
                  >
                    {details?.eventType === "Public" && (
                      <LinearGradient
                        colors={[
                          "rgba(31, 41, 55, 0.50)",
                          "rgba(17, 24, 39, 0.50)",
                        ]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={{
                          borderRadius: 8,
                          borderWidth: 0.8,
                          borderColor: "#374151",
                          alignSelf: "center",
                          paddingVertical: 10,
                          paddingHorizontal: 5,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            columnGap: 10,
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                                ? AppFontStyle.REGULAR_ANYBODY_24
                                : AppFontStyle.REGULAR_ANYBODY_12,
                              { color: AppColors.white },
                            ]}
                          >
                            {details?.eventType === "Public"
                              ? "FREE EVENT"
                              : null}
                          </Text>
                        </View>
                      </LinearGradient>
                    )}
                    {details?.eventType === "Public" ? null : (
                      <LinearGradient
                        colors={[
                          "rgba(31, 41, 55, 0.50)",
                          "rgba(17, 24, 39, 0.50)",
                        ]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={{
                          borderRadius: 8,
                          borderWidth: 0.8,
                          borderColor: "#374151",
                          alignSelf: "center",
                          paddingVertical: 10,
                          paddingHorizontal: 10,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            columnGap: 10,
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                                ? AppFontStyle.REGULAR_ANYBODY_24
                                : AppFontStyle.REGULAR_ANYBODY_12,
                              { color: AppColors.white },
                            ]}
                          >
                            Tickets sold
                          </Text>
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                                ? AppFontStyle.BOLD_ANYBODY_32
                                : AppFontStyle.BOLD_ANYBODY_14,
                              { color: AppColors.white },
                            ]}
                          >
                            {details ? details.minimumAttendees : ""}
                          </Text>
                        </View>
                      </LinearGradient>
                    )}
                    <LinearGradient
                      colors={[
                        "rgba(31, 41, 55, 0.50)",
                        "rgba(17, 24, 39, 0.50)",
                      ]}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 1 }}
                      style={{
                        borderRadius: 8,
                        borderWidth: 0.8,
                        borderColor: "#374151",
                        alignSelf: "center",
                        paddingVertical: 10,
                        paddingHorizontal: 10,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          columnGap: 10,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                              ? AppFontStyle.REGULAR_ANYBODY_24
                              : AppFontStyle.REGULAR_ANYBODY_12,
                            { color: AppColors.white },
                          ]}
                        >
                          {details?.eventType === "Public"
                            ? "Signed-Up"
                            : "Tickets Price"}
                        </Text>
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                              ? AppFontStyle.BOLD_ANYBODY_32
                              : AppFontStyle.BOLD_ANYBODY_14,
                            { color: AppColors.white },
                          ]}
                        >
                          {details?.eventType === "Public"
                            ? details.attendeeIDs.length
                            : details?.ticketPrice}
                        </Text>
                        <Image
                          source={AppImages.icWonDollarIcon}
                          style={{
                            height: 23,
                            width: 23,
                            resizeMode: "contain",
                          }}
                        />
                      </View>
                    </LinearGradient>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      columnGap: deviceSize !== DEVICE_SIZES.SM ? 15 : 1,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        setIsShare(true);
                      }}
                      style={{}}
                    >
                      <Image
                        source={AppImages.Ko_ongoing_share}
                        style={{ height: 50, width: 50, cursor: "pointer" }}
                      />
                    </TouchableOpacity>
                    {timeLeft.days === 0 &&
                    timeLeft.hours === 0 &&
                    timeLeft.minutes === 0 &&
                    timeLeft.seconds === 0 ? (
                      <CommonButton
                        title="Go to live event page"
                        onTap={() => {
                          navigateToScreen(
                            navigation,
                            AppScreens.LiveStreaming,
                            {
                              eventId: eventID,
                            }
                          );
                        }}
                        buttonStyle={styles.btnButTicket}
                        textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                      />
                    ) : !isPlayer ? (
                      !isUserAttendee ? (
                        details?.eventType === "Public" ? (
                          <CommonButton
                            title="Sign-Up"
                            onTap={() => {
                              setOpenSignUp(true);
                            }}
                            buttonStyle={styles.btnSignUpStyle}
                            textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                          />
                        ) : (
                          <CommonButton
                            title="Buy Ticket now"
                            onTap={() => {
                              setIsBuyTicket(true);
                            }}
                            buttonStyle={styles.btnButTicket}
                            textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                          />
                        )
                      ) : details?.eventType === "Public" ? (
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            {
                              color: AppColors.white,
                              width: 170,
                              textAlign: "right",
                              fontSize: 18,
                            },
                          ]}
                          numberOfLines={1}
                          ellipsizeMode="tail"
                        >
                          Already sign-up
                        </Text>
                      ) : (
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            {
                              color: AppColors.white,
                              width: 170,
                              textAlign: "right",
                              fontSize: 18,
                            },
                          ]}
                          numberOfLines={1}
                          ellipsizeMode="tail"
                        >
                          Already Purchased
                        </Text>
                      )
                    ) : (
                      <>
                        <Image
                          source={AppImages.icTicket}
                          style={{
                            width: 100,
                            height: 54,
                            resizeMode: "contain",
                            borderRadius: 10,
                          }}
                        />
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_24,
                            {
                              textAlign: "right",
                            },
                          ]}
                        >
                          {details.attendeeIDs.length ?? 0}
                        </Text>
                      </>
                    )}
                  </View>
                </>
              )}
            </View>
          ) : null}

          {/* Divider - hide for mobile */}
          {deviceSize !== DEVICE_SIZES.XS &&
            deviceSize !== DEVICE_SIZES.SM &&
            deviceSize !== DEVICE_SIZES.MD &&
            deviceSize !== DEVICE_SIZES.LG && (
              <View
                style={{
                  height: 1,
                  backgroundColor: AppColors.gray_C3C3C3,
                  marginVertical: 15,
                }}
              />
            )}

          <View
            style={{
              flexDirection:
                deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                  ? "column"
                  : "row",
            }}
          >
            {/* Overview Tab Content - Mobile */}
            {(deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG) &&
            selectedTab === "Overview" ? (
              <ScrollView
                style={{ flex: 1 }}
                showsVerticalScrollIndicator={false}
              >
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? (
                  <MobileGameShowCard details={details} timeLeft={timeLeft} />
                ) : (
                  <EventDetailScreenCard
                    setIsMinAttendees={setIsMinAttendees}
                    isMinAttendees={isMinAttendees}
                    details={details}
                    userData={userData}
                    timeLeft={timeLeft}
                    hasCheckedIn={isUserCheckedIn}
                    setTimeLeft={setTimeLeft}
                    isStreamConnected={isStreamConnected}
                    isMoreTimeLeft={isMoreTimeLeft}
                    setIsMoreTimeLeft={setIsMoreTimeLeft}
                    screenName="GameShowScreen"
                    IsEventCanceled={IsEventCanceled}
                    isLoading={showLoader}
                    paddingOnTop={false}
                  />
                )}
              </ScrollView>
            ) : null}

            {/* Players Tab Content - Mobile */}
            {(deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG) &&
            selectedTab === "Players" ? (
              <View style={{ flex: 1, marginTop: 10 }}>
                {showLoader ? (
                  <PlayerViewSkeleton />
                ) : (
                  <View style={styles.playersView}>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          color: "#DC2626",

                          fontSize: 12,
                          fontWeight: "700",
                          lineHeight: 13.86,
                          marginBottom: 8,
                        }}
                      >
                        Kaller
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          navigateToScreen(navigation, AppScreens.UserProfile, {
                            userId:
                              details && details?.participantDetails[0]?.userID,
                          });
                        }}
                        style={styles.playerView}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(31, 41, 55, 0.50)",
                            "rgba(17, 24, 39, 0.50)",
                          ]}
                          start={{ x: 0, y: 0 }}
                          end={{ x: 1, y: 1 }}
                          style={{
                            flex: 1,
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            paddingBottom: 15,
                            position: "relative",
                          }}
                        >
                          <Avatar
                            variant="OnGoingPlayerDetail"
                            src={
                              details
                                ? details?.participantDetails[0]?.profilePicture
                                : "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                            }
                          />
                          <Text
                            style={{
                              color: "#FFFFFF",

                              fontSize: 16,
                              fontWeight: "700",
                              marginTop: 12,
                            }}
                          >
                            {details && details?.participantDetails[0]?.userID
                              ? details?.participantDetails[0]?.userID
                              : "Joseb"}
                          </Text>
                          {/* Check-in Status */}
                          <View
                            style={{
                              marginTop: 8,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Text
                              style={{
                                color: details?.checkInStatus?.organiser
                                  ? "#16A34A"
                                  : "#FACC15",

                                fontSize: 12,
                                fontWeight: "600",
                                paddingHorizontal: 10,
                                textAlign: "center",
                              }}
                            >
                              {details?.checkInStatus?.organiser
                                ? "Checked In"
                                : "Check In Pending"}
                            </Text>
                          </View>
                        </LinearGradient>
                      </TouchableOpacity>
                    </View>
                    <View
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        marginHorizontal: 5,
                      }}
                    >
                      <Image
                        source={AppImages.icVsLogo}
                        style={styles.vsImage}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          color: "#DC2626",

                          fontSize: 12,
                          fontWeight: "700",
                          marginBottom: 8,
                        }}
                      >
                        Opponent
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          details?.participantDetails[1]
                            ? navigateToScreen(
                                navigation,
                                AppScreens.UserProfile,
                                {
                                  username:
                                    details &&
                                    details?.participantDetails[1]?.userID,
                                }
                              )
                            : toast.error(
                                "Opponent does not accepted challenge yet , try to send challenge to another opponent!"
                              );
                        }}
                        style={styles.playerView}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(31, 41, 55, 0.50)",
                            "rgba(17, 24, 39, 0.50)",
                          ]}
                          start={[0, 0]}
                          end={[1, 1]}
                          style={{
                            flex: 1,
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            paddingBottom: 15,
                          }}
                        >
                          <Avatar
                            variant="OnGoingPlayerDetail"
                            src={
                              details?.participantDetails[1]
                                ? details?.participantDetails[1]?.profilePicture
                                : AppImages.icEmptyOpponent
                            }
                          />
                          <Text
                            style={{
                              color: "#FFFFFF",

                              fontSize: 16,
                              fontWeight: "700",
                              marginTop: 12,
                            }}
                          >
                            {details?.participantDetails[1]?.userID ||
                              "Challenger"}
                          </Text>
                          {/* Check-in Status */}
                          {details?.participantDetails[1] && (
                            <View
                              style={{
                                marginTop: 8,
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                              }}
                            >
                              <Text
                                style={{
                                  color: details?.checkInStatus?.challenger
                                    ? "#16A34A"
                                    : "#FACC15",
                                  paddingHorizontal: 10,
                                  fontSize: 12,
                                  fontWeight: "600",
                                  textAlign: "center",
                                }}
                              >
                                {details?.checkInStatus?.challenger
                                  ? "Checked In"
                                  : "Check In Pending"}
                              </Text>
                            </View>
                          )}
                        </LinearGradient>
                      </TouchableOpacity>
                    </View>
                  </View>
                )}
              </View>
            ) : null}

            {/* Viewers Tab Content - Mobile */}
            {(deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG) &&
            selectedTab === "Viewers" ? (
              <View style={{ flex: 1, marginTop: 10 }}>
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_16,
                    {
                      marginTop: 10,
                      marginBottom: 15,
                    },
                  ]}
                >
                  Signed up Viewers
                </Text>

                {showLoader ? (
                  <View style={{ marginVertical: 20, marginLeft: 10 }}>
                    <Skeletons
                      height={
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 270
                          : 300
                      }
                      width={
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? "100%"
                          : "61%"
                      }
                      style={{
                        borderRadius: 10,
                      }}
                    />
                  </View>
                ) : (
                  <View style={styles.userView}>
                    <LinearGradient
                      colors={[
                        "rgba(25, 33, 44, 0.5)",
                        "rgba(17, 24, 39, 0.50)",
                      ]}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 1 }}
                      style={{ flex: 1, width: "100%" }}
                    >
                      <View style={{ height: 360 }}>
                        {mergedDetails.length > 0 ? (
                          <ScrollView
                            style={{ flex: 1 }}
                            contentContainerStyle={{
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                            showsVerticalScrollIndicator={false}
                          >
                            {mergedDetails.map((item, index) => (
                              <TouchableOpacity
                                key={index}
                                style={{
                                  alignItems: "center",
                                  marginVertical: 10,
                                  padding: 12,
                                  gap: 10,
                                }}
                                onPress={() => {
                                  navigateToScreen(
                                    navigation,
                                    AppScreens.UserProfile,
                                    {
                                      username: item?.userID,
                                    }
                                  );
                                }}
                              >
                                <View
                                  style={{
                                    backgroundColor:
                                      AppColors.lightPurple_604e74,
                                    borderRadius: 50,
                                    width: 45,
                                    height: 45,
                                    overflow: "hidden",
                                  }}
                                >
                                  <Avatar
                                    src={
                                      item.profilePicture ??
                                      "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                                    }
                                    variant="pastSmallPlayer"
                                  />
                                </View>
                                <Text
                                  style={[
                                    AppFontStyle.REGULAR_ANYBODY_12,
                                    {
                                      color: AppColors.gray_C3C3C3,
                                      textAlign: "center",
                                      marginVertical: 5,
                                    },
                                  ]}
                                >
                                  {item?.userID}
                                </Text>
                              </TouchableOpacity>
                            ))}
                          </ScrollView>
                        ) : (
                          <View
                            style={{
                              flex: 1,
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                              padding: 20,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_16,
                                {
                                  color: AppColors.white,
                                  textAlign: "center",
                                  marginBottom: 10,
                                },
                              ]}
                            >
                              No viewers yet!
                            </Text>
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_14,
                                {
                                  color: AppColors.gray_C3C3C3,
                                  textAlign: "center",
                                },
                              ]}
                            >
                              Sign up to this exciting event and be the first to
                              watch!
                            </Text>
                          </View>
                        )}
                      </View>
                    </LinearGradient>
                  </View>
                )}
              </View>
            ) : null}

            {/* Desktop View - Show all content without tabs */}
            {deviceSize !== DEVICE_SIZES.XS &&
            deviceSize !== DEVICE_SIZES.SM &&
            deviceSize !== DEVICE_SIZES.MD &&
            deviceSize !== DEVICE_SIZES.LG ? (
              <>
                <View
                  style={{
                    marginTop: 20,
                    flex: 0.7,
                  }}
                >
                  {showLoader ? (
                    <PlayerViewSkeleton />
                  ) : (
                    <View style={styles.playersView}>
                      <View>
                        <Text
                          style={{
                            color: "#DC2626",

                            fontSize: 12,
                            fontWeight: "700",
                            lineHeight: 13.8,
                            letterSpacing: 0,
                            marginBottom: 8,
                          }}
                        >
                          Kaller
                        </Text>
                        <TouchableOpacity
                          onPress={() => {
                            navigateToScreen(
                              navigation,
                              AppScreens.UserProfile,
                              {
                                userId:
                                  details &&
                                  details?.participantDetails[0]?.userID,
                              }
                            );
                          }}
                          style={styles.playerView}
                        >
                          <LinearGradient
                            colors={[
                              "rgba(31, 41, 55, 0.50)",
                              "rgba(17, 24, 39, 0.50)",
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 1 }}
                            style={{
                              flex: 1,
                              width: "100%",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              paddingBottom: 15,
                            }}
                          >
                            <Avatar
                              variant="OnGoingPlayerDetail"
                              src={
                                details
                                  ? details?.participantDetails[0]
                                      ?.profilePicture
                                  : "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                              }
                            />
                            <Text
                              style={{
                                color: "#FFFFFF",

                                fontSize: 16,
                                fontWeight: "700",
                                marginTop: 12,
                              }}
                            >
                              {details && details?.participantDetails[0]?.userID
                                ? details?.participantDetails[0]?.userID
                                : "Joseb"}
                            </Text>
                            {/* Check-in Status */}
                            <View
                              style={{
                                marginTop: 8,
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                              }}
                            >
                              <Text
                                style={{
                                  color: details?.checkInStatus?.organiser
                                    ? "#16A34A"
                                    : "#FACC15",
                                  paddingHorizontal: 10,
                                  fontSize: 12,
                                  fontWeight: "600",
                                  textAlign: "center",
                                }}
                              >
                                {details?.checkInStatus?.organiser
                                  ? "Checked In"
                                  : "Check In Pending"}
                              </Text>
                            </View>
                          </LinearGradient>
                        </TouchableOpacity>
                      </View>
                      <View style={{ justifyContent: "center" }}>
                        <Image
                          source={AppImages.icVsLogo}
                          style={styles.vsImage}
                        />
                      </View>
                      <View>
                        <Text
                          style={{
                            color: "#DC2626",

                            fontSize: 12,
                            fontWeight: "700",
                            lineHeight: 13.8,
                            letterSpacing: 0,
                            marginBottom: 8,
                          }}
                        >
                          Opponent
                        </Text>
                        <TouchableOpacity
                          onPress={() => {
                            details?.participantDetails[1]
                              ? navigateToScreen(
                                  navigation,
                                  AppScreens.UserProfile,
                                  {
                                    username:
                                      details &&
                                      details?.participantDetails[1]?.userID,
                                  }
                                )
                              : toast.error(
                                  "Opponent does not accepted challenge yet , try to send challenge to another opponent!"
                                );
                          }}
                          style={styles.playerView}
                        >
                          <LinearGradient
                            colors={[
                              "rgba(31, 41, 55, 0.50)",
                              "rgba(17, 24, 39, 0.50)",
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 1 }}
                            style={{
                              flex: 1,
                              width: "100%",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              paddingBottom: 15,
                            }}
                          >
                            <Avatar
                              variant="OnGoingPlayerDetail"
                              src={
                                details?.participantDetails[1]
                                  ? details?.participantDetails[1]
                                      ?.profilePicture
                                  : AppImages.icEmptyOpponent
                              }
                            />
                            <Text
                              style={{
                                color: "#FFFFFF",

                                fontSize: 16,
                                fontWeight: "700",
                                marginTop: 12,
                              }}
                            >
                              {details?.participantDetails[1]?.userID ||
                                "Challenger"}
                            </Text>
                            {/* Check-in Status */}
                            {details?.participantDetails[1] && (
                              <View
                                style={{
                                  marginTop: 8,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  display: "flex",
                                }}
                              >
                                <Text
                                  style={{
                                    color: details?.checkInStatus?.challenger
                                      ? "#16A34A"
                                      : "#FACC15",
                                    paddingHorizontal: 10,
                                    fontSize: 12,
                                    fontWeight: "600",
                                    textAlign: "center",
                                  }}
                                >
                                  {details?.checkInStatus?.challenger
                                    ? "Checked In"
                                    : "Check In Pending"}
                                </Text>
                              </View>
                            )}
                          </LinearGradient>
                        </TouchableOpacity>
                      </View>
                    </View>
                  )}
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      {
                        marginTop: 20,
                      },
                    ]}
                  >
                    Signed up Viewers
                  </Text>

                  {showLoader ? (
                    <View style={{ marginVertical: 20, marginLeft: 10 }}>
                      <Skeletons
                        height={300}
                        width={"61%"}
                        style={{
                          borderRadius: 10,
                        }}
                      />
                    </View>
                  ) : (
                    <View style={styles.userView}>
                      <LinearGradient
                        colors={[
                          "rgba(25, 33, 44, 0.5)",
                          "rgba(17, 24, 39, 0.50)",
                        ]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={{ flex: 1, width: "100%" }}
                      >
                        <View style={{ height: 360 }}>
                          {mergedDetails.length > 0 ? (
                            <ScrollView
                              style={{ flex: 1 }}
                              contentContainerStyle={{
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 8,
                              }}
                              showsVerticalScrollIndicator={false}
                            >
                              {mergedDetails.map((item, index) => (
                                <TouchableOpacity
                                  key={index}
                                  style={{
                                    alignItems: "center",
                                    marginVertical: 10,
                                    padding: 12,
                                    gap: 10,
                                  }}
                                  onPress={() => {
                                    navigateToScreen(
                                      navigation,
                                      AppScreens.UserProfile,
                                      {
                                        username: item?.userID,
                                      }
                                    );
                                  }}
                                >
                                  <View
                                    style={{
                                      backgroundColor:
                                        AppColors.lightPurple_604e74,
                                      borderRadius: 50,
                                      width: 45,
                                      height: 45,
                                      overflow: "hidden",
                                    }}
                                  >
                                    <Avatar
                                      src={
                                        item.profilePicture ??
                                        "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                                      }
                                      variant="pastSmallPlayer"
                                    />
                                  </View>
                                  <Text
                                    style={[
                                      AppFontStyle.REGULAR_ANYBODY_12,
                                      {
                                        color: AppColors.gray_C3C3C3,
                                        textAlign: "center",
                                        marginVertical: 5,
                                      },
                                    ]}
                                  >
                                    {item?.userID}
                                  </Text>
                                </TouchableOpacity>
                              ))}
                            </ScrollView>
                          ) : (
                            <View
                              style={{
                                flex: 1,
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                padding: 20,
                              }}
                            >
                              <Text
                                style={[
                                  AppFontStyle.BOLD_ANYBODY_16,
                                  {
                                    color: AppColors.white,
                                    textAlign: "center",
                                    marginBottom: 10,
                                  },
                                ]}
                              >
                                No viewers yet!
                              </Text>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_14,
                                  {
                                    color: AppColors.gray_C3C3C3,
                                    textAlign: "center",
                                  },
                                ]}
                              >
                                Sign up to this exciting event and be the first
                                to watch!
                              </Text>
                            </View>
                          )}
                        </View>
                      </LinearGradient>
                    </View>
                  )}
                </View>
              </>
            ) : null}

            {deviceSize !== DEVICE_SIZES.XS &&
              deviceSize !== DEVICE_SIZES.SM &&
              deviceSize !== DEVICE_SIZES.MD &&
              deviceSize !== DEVICE_SIZES.LG && (
                <View style={[styles.eventView, {}]}>
                  {showLoader ? (
                    <View style={{ marginTop: 25 }}>
                      <Skeletons
                        height={50}
                        width={"50%"}
                        style={{
                          borderRadius: 10,
                        }}
                      />
                      <Skeletons
                        height={1}
                        style={{
                          borderRadius: 10,
                        }}
                      />
                      <Skeletons
                        height={557}
                        style={{
                          margin: 10,
                          borderRadius: 10,
                        }}
                      />
                    </View>
                  ) : (
                    <EventChatComponent
                      deviceSize={deviceSize}
                      onChatTap={() => {
                        if (isUserAttendee) {
                          setEventChat(true);
                        } else {
                          toast.error(
                            "Purchase a ticket or sign up for this event to participate in the live chat"
                          );
                        }
                      }}
                      chatID={eventID}
                      title="Event Chat"
                      isSignIn={!isUserAttendee}
                      fetchChatHistoryTrigger={fetchChatHistoryTrigger}
                      resetFetchChatHistoryTrigger={() =>
                        setFetchChatHistoryTrigger(false)
                      }
                      IsEventCanceled={IsEventCanceled}
                      reason={details?.cancellationReason || ""}
                    />
                  )}
                </View>
              )}
          </View>
          {openSignUp && (
            <SignUpModal
              accessToken={accessToken}
              userId={userData.username}
              item={details}
              closeSignUp={(success) => {
                if (success) {
                  setDetails((prevDetails) => ({
                    ...prevDetails,
                    attendeeIDs: [
                      ...prevDetails.attendeeIDs,
                      userData.username,
                    ],
                    attendeeDetails: [
                      ...(prevDetails.attendeeDetails || []),
                      {
                        userID: userData.username,
                        profilePicture:
                          userProfileData?.profilePicture ||
                          userData?.profilePicture ||
                          "",
                      },
                    ],
                  }));
                  setOpenSignUp(false);
                  setFetchChatHistoryTrigger(true);
                }
                setOpenSignUp(false);
              }}
              setIsSignUp={setOpenSignUp}
            />
          )}
          {isBuyTicket && userProfileData && (
            <BuyTicketModal
              accessToken={accessToken}
              item={details}
              userData={userData}
              userProfileData={userProfileData}
              closeButTicket={(success) => {
                if (success) {
                  setDetails((prevDetails) => ({
                    ...prevDetails,
                    attendeeIDs: [
                      ...prevDetails.attendeeIDs,
                      userData.username,
                    ],
                    attendeeDetails: [
                      ...(prevDetails.attendeeDetails || []),
                      {
                        userID: userData.username,
                        profilePicture:
                          userProfileData?.profilePicture ||
                          userData?.profilePicture ||
                          "",
                      },
                    ],
                  }));
                  setIsBuyTicket(false);
                  setFetchChatHistoryTrigger(true);
                }
                setIsBuyTicket(false);
              }}
              setIsGetTicket={setIsBuyTicket}
            />
          )}

          {(deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG) && (
            <>
              {isUserAttendee && chatConnected && (
                <MobileChatBottomSheet
                  visible={eventChat}
                  onClose={() => setEventChat(false)}
                  sendLike={sendLike}
                  alreadyLiked={alreadyLiked}
                  setOrganizerData={setOrganizerData}
                  setAudienceData={setAudienceData}
                />
              )}

              {eventChat && isUserAttendee && !chatConnected && (
                <View
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: [{ translateX: -150 }, { translateY: -50 }],
                    zIndex: 1000,
                    backgroundColor: "rgba(0,0,0,0.9)",
                    padding: 20,
                    borderRadius: 10,
                    width: 300,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setEventChat(false)}
                    style={{ position: "absolute", top: 10, right: 10 }}
                  >
                    <Text style={{ color: AppColors.white, fontSize: 20 }}>
                      ×
                    </Text>
                  </TouchableOpacity>
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      {
                        color: AppColors.white,
                        marginBottom: 10,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Connecting to chat...
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, textAlign: "center" },
                    ]}
                  >
                    Please wait while we connect you to the chat
                  </Text>
                </View>
              )}
            </>
          )}

          {isShare && (
            <InviteSocialMediaModal
              accessToken={""}
              challengeDetails={{}}
              showModal={isShare}
              setShowModal={setIsShare}
              eventType={"GameShowScreen"}
              eventID={eventID}
              status={details?.status}
              heading={"Share on social media"}
            />
          )}

          {showGetReadyModal && (
            <GetReadyModal
              visible={showGetReadyModal}
              onClose={() => setShowGetReadyModal(false)}
              onCountdownComplete={() => {
                setShowGetReadyModal(false);
                navigateToScreen(navigation, AppScreens.LiveStreaming, {
                  eventId: eventID,
                });
              }}
              countdownSeconds={10}
            />
          )}
        </ScrollView>
      </View>

      {/* Sticky Chat Button for Mobile - Outside main container for proper positioning */}
      {(deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.MD ||
        deviceSize === DEVICE_SIZES.LG) && (
        <View
          style={{
            position: "absolute",
            bottom: 20,
            right: 20,
            zIndex: 9999,
          }}
        >
          <Pressable
            onPress={() => {
              if (isUserAttendee) {
                setEventChat(true);
                console.log(
                  "Sticky chat button clicked! Setting eventChat to true"
                );
                console.log(
                  "Current state - isUserAttendee:",
                  isUserAttendee,
                  "chatConnected:",
                  chatConnected
                );
              } else {
                toast.error(
                  "Purchase a ticket or sign up for this event to participate in the live chat"
                );
              }
            }}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: 50,
              width: 64,
              height: 64,
              justifyContent: "center",
              alignItems: "center",
              borderWidth: 3,
              borderColor: "#DC2626",
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 4 },
              shadowOpacity: 0.3,
              shadowRadius: 4.65,
              elevation: 8,
            }}
          >
            <Image
              source={AppImages.Ko_Chat}
              style={{ width: 32, height: 32, tintColor: "#DC2626" }}
              resizeMode="contain"
            />
          </Pressable>
        </View>
      )}
    </>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "2.5%",
    },
    countdownContainer: {
      backgroundColor: "transparent",
      borderRadius: 20,
      padding: 20,
      marginBottom: 20,
    },
    eventView: {
      marginTop: 5,
      alignSelf: "flex-start",
      flex: 0.5,
    },
    vsImage: {
      height: 100,
      width: 80,
      marginVertical: 10,
      marginTop: 50,
      alignSelf: "center",
      resizeMode: "contain",
    },
    playerImg: {
      width: 91,
      height: 95,
      marginVertical: 10,
    },
    timeContainer: {
      flexDirection: "row",
      columnGap: 50,
      justifyContent: "center",
      marginBottom: 20,
    },
    eventDetailsContainer: {
      alignSelf: "flex-end",
      marginBottom: 10,
      paddingVertical: 20,
    },
    userView: {
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      marginVertical: 20,
      width: "75%",
      overflow: "hidden",
    },
    gameshowOuterView: {
      margin: 5,
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      paddingHorizontal: 10,
      overflow: "hidden",
    },
    chatOuterView: {
      margin: 5,
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      paddingHorizontal: 10,
      marginVertical: 10,
      overflow: "hidden",
    },
    playersView: {
      width: "75%",
      flexDirection: "row",
      gap: 10,
    },
    playerView: {
      margin: 5,
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      alignItems: "center",
      overflow: "hidden",
    },
    eventDetils: {
      flexDirection: "row",
      gap: 10,
      marginTop: 25,
    },
    btnSignUpStyle: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.buttonRed_DC2626,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 4,
    },
    btnEventChatStyle: {
      paddingVertical: 8,
      paddingHorizontal: 16,
      backgroundColor: "transparent",
      borderWidth: 1.5,
      borderColor: "#DC2626",
      shadowOpacity: 0,
      height: "auto",
      borderRadius: 6,
      gap: 10,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
    btnEventChatText: {
      color: "#DC2626",
      fontSize: 14,
      fontWeight: "600",
      lineHeight: 18,
    },
    btnButTicket: {
      paddingVertical: 0,
      paddingHorizontal: 55,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 7,
    },
    btnChat: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      marginTop: 10,
      borderRadius: 7,
    },
    freeEventView: {
      flexDirection: "row",
      columnGap: 30,
    },
    deviceflexDirection: {
      flexDirection: "row",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "2.5%",
      },
      countdownContainer: {
        backgroundColor: "transparent",
        borderRadius: 20,
        padding: 20,
        marginBottom: 20,
      },
      btnButTicket: {
        paddingVertical: 0,
        paddingHorizontal: 45,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 7,
      },
      freeEventView: {
        flexDirection: "row",
        columnGap: 5,
      },
      timeContainer: {
        flexDirection: "row",
        columnGap: 50,
        justifyContent: "center",
        marginBottom: 20,
      },
      userView: {
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 10,
        marginVertical: 20,
        width: "90%",
      },
      eventDetailsContainer: {
        alignSelf: "center",
        flex: 1,
        marginBottom: 10,
        paddingVertical: 20,
      },
      gameshowOuterView: {
        margin: 5,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
      },
      eventView: {
        marginTop: 5,
        alignSelf: "flex-start",
        flex: 0.9,
        width: "100%",
      },
      eventDetils: {
        flexDirection: "row",
        columnGap: 17,
        marginTop: 25,
      },
      btnSignUpStyle: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.buttonRed_DC2626,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 4,
      },
      btnChat: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginTop: 10,
        borderRadius: 7,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      chatOuterView: {
        margin: 5,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
        marginVertical: 10,
      },
      vsImage: {
        height: 100,
        width: 80,
        marginVertical: 10,
        alignSelf: "center",
        resizeMode: "contain",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "2.5%",
      },
      countdownContainer: {
        backgroundColor: "transparent",
        borderRadius: 20,
        padding: 20,
        marginBottom: 20,
      },
      btnButTicket: {
        paddingVertical: 0,
        paddingHorizontal: 55,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 7,
      },
      freeEventView: {
        flexDirection: "row",
        columnGap: 10,
      },
      userView: {
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 10,
        marginVertical: 20,
        marginRight: 400,
        width: "85%",
      },
      eventView: {
        marginTop: 5,
        alignSelf: "flex-start",
        flex: 0.8,
      },
      timeContainer: {
        flexDirection: "row",
        columnGap: 50,
        justifyContent: "center",
        marginBottom: 20,
      },
      eventDetailsContainer: {
        alignSelf: "center",
        flex: 1,
        marginBottom: 10,
        paddingVertical: 20,
      },
      gameshowOuterView: {
        margin: 5,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
      },
      eventDetils: {
        flexDirection: "row",
        columnGap: 20,
        marginTop: 25,
      },
      btnSignUpStyle: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.buttonRed_DC2626,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 4,
      },
      btnChat: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginTop: 10,
        borderRadius: 7,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      chatOuterView: {
        margin: 5,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
        marginVertical: 10,
      },
      vsImage: {
        height: 100,
        width: 80,
        resizeMode: "contain",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "2.5%",
      },
      freeEventView: {
        flexDirection: "column",
        columnGap: 0,
      },
      btnButTicket: {
        paddingVertical: 0,
        paddingHorizontal: 25,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 7,
        bottom: 10,
      },
      countdownContainer: {
        backgroundColor: "transparent",
        borderRadius: 20,
        padding: 20,
        marginBottom: 20,
      },
      playersView: {
        width: "100%",
        flexDirection: "row",
        gap: 0,
        justifyContent: "center",
        alignContent: "center",
      },
      eventView: {
        marginTop: 5,
        alignSelf: "flex-start",
        flex: 1,
        width: "100%",
      },
      timeContainer: {
        flexDirection: "row",
        columnGap: 50,
        justifyContent: "center",
        marginBottom: 20,
      },
      userView: {
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 10,
        marginVertical: 20,
        marginHorizontal: 0,
        width: "auto",
      },
      eventDetailsContainer: {
        borderRadius: 10,
        alignSelf: "flex-end",
        flex: 1,
        marginBottom: 10,
        paddingVertical: 20,
      },
      gameshowOuterView: {
        margin: 0,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
      },
      eventDetils: {
        flexDirection: "row",
        columnGap: 17,
        marginTop: 25,
      },
      btnSignUpStyle: {
        paddingVertical: 0,
        paddingHorizontal: 2,
        backgroundColor: AppColors.buttonRed_DC2626,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 4,
      },
      btnChat: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginTop: 10,
        borderRadius: 7,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      chatOuterView: {
        margin: 5,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
      },
      vsImage: {
        height: 180,
        width: 150,
        resizeMode: "contain",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "2.5%",
      },
      countdownContainer: {
        backgroundColor: "transparent",
        borderRadius: 20,
        padding: 20,
        marginBottom: 20,
      },
      btnButTicket: {
        paddingVertical: 0,
        paddingHorizontal: 35,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 7,
        bottom: 0,
      },
      freeEventView: {
        flexDirection: "column",
        columnGap: 10,
      },
      playersView: {
        width: "100%",
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignContent: "center",
      },
      eventView: {
        marginTop: 5,
        alignSelf: "flex-start",
        flex: 0.5,
        width: "100%",
      },
      userView: {
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 10,
        marginVertical: 20,
        marginHorizontal: 0,
        width: "auto",
      },
      timeContainer: {
        flexDirection: "row",
        columnGap: 20,
        justifyContent: "center",
        marginBottom: 20,
      },
      eventDetailsContainer: {
        alignSelf: "center",
        flex: 1,
        marginBottom: 10,
        paddingVertical: 20,
        marginHorizontal: 15,
      },
      gameshowOuterView: {
        margin: 0,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
      },
      eventDetils: {
        flexDirection: "row",
        gap: 10,
        marginTop: 25,
        alignItems: "center",
        justifyContent: "space-between",
      },
      btnSignUpStyle: {
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.buttonRed_DC2626,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 4,
        flex: 1,
      },
      btnEventChatStyle: {
        paddingVertical: 8,
        paddingHorizontal: 12,
        backgroundColor: "transparent",
        borderWidth: 1.5,
        borderColor: "#DC2626",
        shadowOpacity: 0,
        height: 40,
        borderRadius: 6,
        gap: 8,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
      },
      btnChat: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginTop: 10,
        borderRadius: 7,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      chatOuterView: {
        margin: 5,
        backgroundColor: AppColors.grayColor_282828,
        borderRadius: 12,
        paddingHorizontal: 10,
        marginVertical: 10,
      },
      vsImage: {
        height: 100,
        width: 80,
        marginTop: 50,
        alignSelf: "center",
        resizeMode: "contain",
      },
    },
  }
);
